import { render, staticRenderFns } from "./PromoShowData.vue?vue&type=template&id=3dd142ce&"
import script from "./PromoShowData.vue?vue&type=script&lang=js&"
export * from "./PromoShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports